export const MIME_TYPES = {
  text: 'text/plain',
  json: 'application/json',
} as const
